/**
 * JS file is needed because TypeScript can't use JSON imports
 * for UMD builds.
 */
import { version } from '../../package.json';
export default version;
//# sourceMappingURL=sdkVersion.js.map